import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const refresh = useCallback(() => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null)), []);
  useEffect(() => { refresh(); }, [refresh]);
  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    await refresh();
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };
  return <AuthCtx.Provider value={{ user, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
